<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredAgents"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
      >
        <template #top>
          <div
            class="d-flex justify-space-between align-center pa-4 flex-wrap"
            style="gap: 12px"
          >
            <span class="text-h5">Support Agents</span> <!--TODO: Add the title from th-->
            <div class="d-flex align-center flex-wrap" style="gap: 12px">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 280px; max-width: 100%"
              />
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="showCreateDialog = true"
              >
                Add Agent
              </v-btn>
            </div>
          </div>
        </template>

        <template #[`item.agent_name`]="{ item }">
          <span class="font-weight-medium">{{ item.agent_name }}</span>
        </template>

        <template #[`item.agent_status`]="{ item }">
          <v-chip
            size="small"
            :color="isAgentActive(item) ? 'success' : 'grey'"
            variant="tonal"
          >
            {{ isAgentActive(item) ? "Active" : "Inactive" }}
          </v-chip>
        </template>

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center" style="gap: 4px">
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click="openEditDialog(item)"
            >
              <v-icon>mdi-pencil</v-icon>
              <v-tooltip activator="parent" location="top">Edit</v-tooltip>
            </v-btn>
            <v-btn
              icon
              size="small"
              variant="text"
              color="error"
              @click="openDeleteDialog(item)"
            >
              <v-icon>mdi-delete</v-icon>
              <v-tooltip activator="parent" location="top">Delete</v-tooltip>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <AddSupportAgentDialog
      v-model="showCreateDialog"
      @created="handleAgentCreated"
    />

    <EditSupportAgentDialog
      v-model="showEditDialog"
      :agent_id="selectedAgent?.agent_id || ''"
      :agent_name="selectedAgent?.agent_name || ''"
      :agent_email_id="selectedAgent?.agent_email_id || ''"
      @updated="handleAgentUpdated"
    />

    <DeleteSupportAgentDialog
      v-model="showDeleteDialog"
      :agent="selectedAgent"
      @deleted="handleAgentDeleted"
    />
  </div>
</template>

<script>
import AddSupportAgentDialog from "@/components/RCSSupport/Dialogs/AddSupportAgentDialog.vue";
import EditSupportAgentDialog from "@/components/RCSSupport/Dialogs/EditSupportAgentDialog.vue";
import DeleteSupportAgentDialog from "@/components/RCSSupport/Dialogs/DeleteSupportAgentDialog.vue";
import AgentApi from "@/mixins/RCSSupport/AgentApi";

export default {
  name: "RCSSupportAgents",
  mixins: [AgentApi],
  components: {
    AddSupportAgentDialog,
    EditSupportAgentDialog,
    DeleteSupportAgentDialog,
  },
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      selectedAgent: null,
      search: "",
      tableLoading: false,
      windowHeight: window.innerHeight,
      headers: [
        { title: "Name", key: "agent_name", sortable: true },
        { title: "Email", key: "agent_email_id", sortable: true },
        { title: "Status", key: "agent_status", sortable: true, width: "120px" },
        {
          title: "Actions",
          key: "actions",
          sortable: false,
          align: "center",
          width: "120px",
        },
      ],
      agents: [],
    };
  },
  computed: {
    noDataText() {
      return "No support agents found.";
    },
    tableHeight() {
      return Math.max(320, this.windowHeight - 220);
    },
    filteredAgents() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.agents;
      return this.agents.filter((agent) =>
        [agent.agent_name, agent.agent_email_id, agent.agent_status]
          .join(" ")
          .toLowerCase()
          .includes(q)
      );
    },
  },
  async mounted() {
    window.addEventListener("resize", this.onResize);
    await this.loadAgents();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    isAgentActive(agent) {
      return String(agent?.agent_status || "").toUpperCase() === "ACTIVE";
    },
    async loadAgents() {
      this.tableLoading = true;
      try {
        await this.fetchAgents();
        this.agents = this.agentsList;
      } catch (error) {
        console.error("Error loading agents:", error);
        this.agents = [];
      } finally {
        this.tableLoading = false;
      }
    },
    async handleAgentCreated() {
      await this.loadAgents();
    },
    openEditDialog(agent) {
      this.selectedAgent = agent;
      this.showEditDialog = true;
    },
    openDeleteDialog(agent) {
      this.selectedAgent = agent;
      this.showDeleteDialog = true;
    },
    async handleAgentUpdated() {
      this.selectedAgent = null;
      await this.loadAgents();
    },
    async handleAgentDeleted() {
      this.selectedAgent = null;
      await this.loadAgents();
    },
  },
};
</script>
